"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AddPillButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _excluded = ["innerRef", "className", "data-test-id", "children"];
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.005 3a1 1 0 0 1 1 1v7.01H20a1 1 0 1 1 0 2h-6.995V20a1 1 0 1 1-2 0v-6.99H4a1 1 0 1 1 0-2h7.005V4a1 1 0 0 1 1-1z"
  }));
};
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "button": "AddPillButton__button__3N2cO",
  "pill-span": "AddPillButton__pill-span__1wHOl",
  "pillSpan": "AddPillButton__pill-span__1wHOl"
}; 
require('./AddPillButton.css');
var AddPillButton = exports.AddPillButton = /*#__PURE__*/_react.default.memo(function (_ref) {
  var innerRef = _ref.innerRef,
    className = _ref.className,
    testId = _ref['data-test-id'],
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    ref: innerRef,
    "data-test-id": "".concat(testId, "-button"),
    className: (0, _classnames.default)(className, styles.button),
    type: "button"
  }, props), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(PlusIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "".concat(testId, "-span")
  }, children));
});
var AddPillButtonWithRef = function AddPillButtonWithRef(props, ref) {
  return /*#__PURE__*/_react.default.createElement(AddPillButton, (0, _extends2.default)({
    innerRef: ref
  }, props));
};
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef(AddPillButtonWithRef);
//# sourceMappingURL=AddPillButton.js.map